import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=a42f835c&"
import script from "./AlertsTable.vue?vue&type=script&lang=ts&"
export * from "./AlertsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports